module.exports = __webpack_public_path__ + "static/img/dian_yangan3.5070e04e.png";